import { TRPCPost } from '@/infrastructure/axios';
import { API_PREFIX } from '@/infrastructure/axios/code';
import { logger } from '@/infrastructure/logger';
import {
  IModifyIssueListStatusReq,
  IModifyIssueStatusRsp,
} from '@/proto/manage';

export const modifyIssueStatusBatch = async (params: IModifyIssueListStatusReq):
Promise<IModifyIssueStatusRsp | undefined> => {
  try {
    return await TRPCPost<IModifyIssueStatusRsp>(`/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.IssueTrack/ModifyIssueListStatus`, params);
  } catch (e) {
    logger.error('modifyIssueStatusBatch err', e);
    return undefined;
  }
};

